import React from "react";
import { Table, Button } from "reactstrap";
import ModalCordon from "./cordonModal";

export default class TablaAlumnos extends React.Component {
  render() {
    if (!this.props.data) return null;
    console.warn(this.props)
    return (
      <Table hover className="mb-0">
        <thead>
          <tr>
          
            <th className="text-center">nivel</th>
            <th className="text-center">
descripción            </th>
<th className="text-center">ver detalle</th>

          </tr>
        </thead>
        <tbody>
          {this.props.data.map((e, index) => {
            return (
              <tr key={e.id}>
                 
                <td className="text-center">{e.nivel}</td>
                <td className="text-center">{e.descripcion}</td>

                
                <td className="text-center">
                                <ModalCordon cinturon={e}></ModalCordon>
                              </td>

              </tr>
            );
          })}
          <div>
            <nav
              aria-label="Page"
              className="d-flex w-100 justify-content-center  "
            >
              <ul className="pagination">
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(0)}
                >
                  <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">«</span>
                    <span className="sr-only"> Pagina Anterior</span>
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link">{this.props.page}</a>
                </li>
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(1)}
                >
                  <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">»</span>
                    <span className="sr-only">Proxima Pagina</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// src/Pages/ObjetivosDelJuego/Cordon/component/AlumnosList.js